"use strict";
exports.__esModule = true;
exports.checkPermissionsForDepartments = exports.checkPermissionsForSubunits = exports.getEnabledPermissionsForTarget = exports.checkIfProfileHasNeededPermissions = void 0;
var constants_1 = require("./constants");
var checkIfProfileHasNeededPermissions = function (profilePermissions, permissionIds) {
    if (permissionIds === void 0) { permissionIds = []; }
    if (profilePermissions.type === constants_1.UserProfileType.Admin ||
        profilePermissions.type === constants_1.UserProfileType.ApiKey) {
        return true;
    }
    if (permissionIds.length === 0) {
        return false;
    }
    return permissionIds.every(function (permissionId) {
        return profilePermissions.enabledPermissionIds.includes(permissionId);
    });
};
exports.checkIfProfileHasNeededPermissions = checkIfProfileHasNeededPermissions;
var getEnabledPermissionsForTarget = function (permissions, target, type) {
    return permissions.filter(function (permission) {
        return permission.name.endsWith(target + "." + type);
    });
};
exports.getEnabledPermissionsForTarget = getEnabledPermissionsForTarget;
var checkPermissionsForSubunits = function (permissions, target, type, subunitIds) {
    var enabledPermissions = (0, exports.getEnabledPermissionsForTarget)(permissions, target, type);
    return subunitIds.every(function (subunitId) {
        return enabledPermissions.find(function (permission) { return permission.subunitId === subunitId; });
    });
};
exports.checkPermissionsForSubunits = checkPermissionsForSubunits;
var checkPermissionsForDepartments = function (permissions, target, type, departmentIds) {
    var enabledPermissions = (0, exports.getEnabledPermissionsForTarget)(permissions, target, type);
    return departmentIds.every(function (departmentId) {
        return enabledPermissions.find(function (permission) { return permission.departmentId === departmentId; });
    });
};
exports.checkPermissionsForDepartments = checkPermissionsForDepartments;
